var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrTasks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H16.6716C17.0694 0.5 17.4509 0.658035 17.7322 0.93934L19.6464 2.85355L22.0607 5.26777C22.342 5.54907 22.5 5.9306 22.5 6.32843V22C22.5 22.8284 21.8284 23.5 21 23.5H2C1.17157 23.5 0.5 22.8284 0.5 22V2Z",
    stroke: "#7A5AF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 0.5V3.5C17.5 4.60457 18.3954 5.5 19.5 5.5H22.5",
    stroke: "#7A5AF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9H18",
    stroke: "#7A5AF8",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13H18",
    stroke: "#7A5AF8",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 17H18",
    stroke: "#7A5AF8",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrTasks);
export default __webpack_public_path__ + "static/media/CurrTasks.9bd63fcb1ce158c469899594c3b16b98.svg";
export { ForwardRef as ReactComponent };